import { Controller, useFormContext } from 'react-hook-form';
import { IMaskInput } from 'react-imask';
import { clsx } from 'clsx';
import { SvgCloseSearch } from '@/components/icons';
import { ControlledInputProps } from '@/components/form/ControlledInput/ControlledInput.types';
import s from '@/components/form/ControlledInput/ControlledInput.module.scss';

interface Props extends ControlledInputProps {
  maskOptions: any[];
  unmask?: boolean;
}

export const ControlledInputWithMask = (props: Props) => {
  const {
    fieldName,
    placeholder = 'Введите',
    disabled,
    className,
    maskOptions,
    unmask = true,
    label,
  } = props;

  const { control, resetField } = useFormContext();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div className={clsx(s.inputWrapper, className, { [s.input_disabled]: disabled })}>
            {label && <div className={s.inputWrapper__label}>{label}</div>}
            <IMaskInput
              className={clsx(s.input, className, {
                [s.input_disabled]: disabled,
                [s.input_error]: error,
              })}
              unmask={unmask}
              mask={maskOptions}
              value={value}
              // onAccept={(value) => onChange(value)} check it if something's wrong
              onAccept={(inputValue) => inputValue !== value && onChange(inputValue)}
              placeholder={placeholder}
              disabled={disabled}
              type={'text'}
            />
            {value && (
              <button
                type="button"
                onClick={() => resetField(fieldName)}
                className={clsx(s.input__cross, { [s.input__cross_shifted]: label })}
              >
                <SvgCloseSearch />
              </button>
            )}
            <span className={clsx(s.input__errorHint, { [s.input__errorHint_visible]: error })}>
              {error?.message}
            </span>
          </div>
        );
      }}
    />
  );
};